"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.match = exports.eq = void 0;
var matched = function (x) { return ({
    otherwise: function () { return x; },
    on: function () { return matched(x); }
}); };
var match = function (x) { return ({
    on: function (predicate, fn) { return (predicate(x) ? matched(fn(x)) : match(x)); },
    otherwise: function (fn) { return fn(x); }
}); };
exports.match = match;
var eq = function (x) {
    return function (y) {
        return x === y;
    };
};
exports.eq = eq;
match.eq = exports.eq;
//# sourceMappingURL=match.js.map